import React from "react";
import studentsImage from "./images/about-side-image.svg";

function Aboutus(props) {
  return (
    <div>
      <section id="aboutus">
        <div className="flex-2">
          <div className="place-left">
            <h2>about us</h2>
            <h4>Detailed And Highly Recommended Resources </h4>
            <p>
              CBA Study App is both a quick self learning and self teaching
              environment that helps students to adapt and build their study
              habit through daily tracking and persistence in daily routine
              study process, such as setting signal reminders, and current
              progress in each course. We are on a mission to revolutionize the
              way students engage with their academic material by adapting our
              product to suit all your needs for studies starting from jotting
              down notes on the dashboard to adding to do and also receiving an
              overview of what you covered within an interval of time. Our
              platform is dedicated to providing a dynamic and interactive
              learning environment, making studying efficient, enjoyable, and
              effective for students of all ages and academic levels.
            </p>
          </div>
          <div className="place-right">
            <img src={studentsImage} alt="students" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Aboutus;
